import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import * as copilot from '@janus.team/janus-copilot';
import { isProd, isRacker } from '../config/index';
import { proxyFetch } from 'proxy';

const url = isProd() ?
`https://watchman.api.manage.rackspace.com`:
`https://watchman.api.dev.manage.rackspace.com`;

const rejectOnNon200 = (res) => (
  res.ok ? Promise.resolve(res) : Promise.reject(res)
);

const buildHeaders = (baseHeaders, { domainId }) => {
  const domainIdHeaders = domainId ? { 'x-tenant-id': domainId } : {};
  return _.merge({}, baseHeaders, domainIdHeaders);
};

const useDomainId = () => {
  const sessionContext = React.useContext(copilot.context.session);
  const domainIdFromParams = useParams()?.domainId;
  const domainIdFromSession = _.get(sessionContext, ['session', 'user', 'RAX-AUTH:domainId']);
  return domainIdFromParams || domainIdFromSession;
};

const generateType = (webhooks) => _.map(webhooks, (hook) => {
  const relStartTrimmed = hook.rel.slice(hook.rel.indexOf('-') + 1);
  const relStartAndEndTrimmed = relStartTrimmed.slice(0, relStartTrimmed.lastIndexOf('-'));
  return {...hook, type: relStartAndEndTrimmed};
});

export const fetchWebhooksForAccount = async (tenantId, domainId, ...args) => {
  if (!tenantId) { return {}; }
  if (isRacker() && !domainId) { return {}; }

  const webhooksUrl = `${url}/v1/${tenantId}/webhooks`;
  const options = { method: 'GET', headers: buildHeaders({}, { domainId }) };
  return proxyFetch(webhooksUrl, options)
    .then(rejectOnNon200)
    .then(_.method('parseJson'))
    .then(_.property('webhooks'))
    .then(generateType);
};

export const useWebhooksForAccountQuery = (tenantId) => {
  const domainId = useDomainId(); 
  return useQuery(['webhooks-for-customer-account', tenantId, domainId], (...args) => fetchWebhooksForAccount(tenantId, domainId, ...args), { retry: false });
};